export default () => {
  const firstPopup = document.querySelector('.first-post');

  if(firstPopup){
    firstPopup.addEventListener('click', () => {
      firstPopup.style.display = 'none';
    });
  };

};